import Button from "@components/Button/Button";
import {
  ButtonSize,
  KeywordsButtonDefaultProps,
} from "@components/Button/utlis/types";
import { faCheck, faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@util/helpers";

export default function KeywordButtonDefault({
  handleClick,
  isTagFollowed,
  isLoading,
  iconClassName,
}: KeywordsButtonDefaultProps): React.ReactElement {
  return (
    <Button
      onClick={handleClick}
      className={cn("ml-auto flex border-0", {
        "border-gray-850": isTagFollowed,
      })}
      buttonSize={ButtonSize.medium}
      aria-label={"Follow tag"}
      testId="keyword-button-default-component"
    >
      <FontAwesomeIcon
        icon={isLoading ? faSpinner : isTagFollowed ? faCheck : faPlus}
        spin={isLoading}
        size="sm"
        color="text-gray-850"
        className={iconClassName}
      />
    </Button>
  );
}
